import PinoLogger, { Logger, StreamEntry, TransportSingleOptions, multistream } from 'pino';
import PinoHttp, { HttpLogger } from 'pino-http';

let _logger: Logger | undefined;

/**
 * @param pretty
 * @returns
 */
// eslint-disable-next-line sonarjs/cognitive-complexity
export function getLogger(pretty = false, client: boolean = false): Logger {
  if (!_logger) {
    let transport: TransportSingleOptions | undefined;

    if (pretty) {
      transport = {
        target: 'pino-pretty'
      };
    }
    if (typeof window !== 'undefined') {
      const streams: StreamEntry[] = [
        { level: 'info', stream: process.stdout },
        { level: 'error', stream: process.stderr },
        { level: 'fatal', stream: process.stderr }
      ];

      const stream = typeof multistream === 'function' ? multistream(streams) : undefined;
      if (stream) {
        _logger = PinoLogger(
          {
            ...(client ? { browser: { asObject: true } } : {}),
            level: 'info',
            transport
          },
          stream
        );
      } else {
        _logger = PinoLogger({
          ...(client ? { browser: { asObject: true } } : {}),
          level: 'info',
          transport
        });
      }
    } else {
      _logger = PinoLogger({
        browser: { asObject: true },
        level: 'info',
        transport
      });
    }
  }
  return _logger;
}
let _httpLogger: HttpLogger | undefined;

/**
 * @returns
 */
export function getHttpLogger(): HttpLogger {
  if (!_httpLogger) {
    const streams: StreamEntry[] = [
      { level: 'info', stream: process.stdout },
      { level: 'error', stream: process.stderr },
      { level: 'fatal', stream: process.stderr }
    ];

    const logger = PinoLogger({ level: 'info' }, multistream(streams));

    _httpLogger = PinoHttp({
      logger: logger as any
    });
  }
  if (process.env.NODE_ENV === 'development') {
    _httpLogger.logger.level = 'fatal';
  }
  return _httpLogger;
}
